/*
 * @Author: Hugo
 * @Date: 2020-10-13 13:34:12
 * @LastEditTime: 2020-10-15 19:58:56
 * @LastEditors: Please set LastEditors
 * @Description: 树类
 * @FilePath: /Workbench_Front_Support/src/workbench_front/common/models/Tree/index.js
 */

import Node from "../Node";
export default class Tree {
    constructor(data) {
        this._root = data instanceof Node ? data : this.initNode(data);
    }
    initNode(data) {
        return new Node(data);
    }
    /**
     * 深度优先遍历(非递归)
     * @param {Function} callback
     */
    traverseDF(callback) {
        let nodes = [];
        let stack = [];
        let curNode = this._root;
        if (curNode) {
            stack.push(curNode);
            while(stack.length != 0) {
                curNode = stack.pop();
                nodes.push(curNode);
                let children = curNode.children;
                for (let i = children.length - 1; i >= 0; i--) {
                    stack.push(children[i]);
                }
            }
        }
        nodes.forEach((node) => {
            callback(node);
        });
    }
    /**
     * 广度优先遍历(非递归)
     * @param {Function} callback
     */
    traverseBF(callback) {
        let queue = [];
        // 入队操作
        queue.unshift(this._root);
        // 出队
        let curNode = queue.pop();
        while(curNode) {
            for (let i = 0, l = curNode.children.length; i < l; i++) {
                // 子节点入队
                queue.unshift(curNode.children[i]);
            }
            callback(curNode);
            // 一个节点出队
            curNode = queue.pop();
        }

    }
    /**
     * 搜索树中的节点
     * @param {Function} callback
     * @param {Function} traversal
     */
    contains(callback, traversal) {
        traversal.call(this, callback)
    }
    /**
     * 向指定节点(toData)添加节点(data)
     * @param {Any} data
     * @param {Any} toData
     * @param {Function} traversal
     */
    add(data, toData, traversal) {
        let child = this.initNode(data);
        let parent = null;
        let callback = function(node) {
            if (node.data === toData) {
                parent = node;
            }
        };
        this.contains(callback, traversal);
        if (parent) {
            parent.children.push(child);
            child.parent = parent;
        } else {
            throw new Error('Cannot add node to a non-existent parent.');
        }
        return child;
    }
    /**
     * 从指定节点(fromData)中移除子节点(data)及其所有子集
     * @param {*} data
     * @param {*} fromData
     * @param {*} traversal
     */
    remove(data, fromData, traversal) {
        let parent = null;
        let childToRemove = null;
        let index;
        let callback = function(node) {
            if (node.data === fromData) {
                parent = node;
            }
        };
        this.contains(callback, traversal);
        if (parent) {
            index = parent.children.findIndex((el) => {
                return el.data === data;
            });
            if (index > -1) {
                childToRemove = parent.children.splice(index, 1);
            } else {
                throw new Error('Node to remove does not exist.')
            }
        } else {
            throw new Error('Parent does not exist.')
        }
        return childToRemove;
    }

    getRoot() {
        return this._root;
    }

}
